/**
 * Core field type definitions
 */
export enum FieldType {
  // Basic fields
  TEXT = 'text',
  NUMBER = 'number',
  TEXTAREA = 'textarea',

  // Choice fields
  MULTIPLE_CHOICE = 'multiple_choice',
  SINGLE_CHOICE = 'single_choice',
  DROPDOWN = 'dropdown',
  YES_NO = 'yes_no',

  // Date and time fields
  DATE = 'date',
  TIME = 'time',

  // Special fields
  COUNTRY = 'country',
  KEYWORD_FIELD = 'keyword_field',
  REPEATABLE_KEYWORD_FIELD = 'repeatable_keyword_field',
  COMPLEX_KEYWORD_FIELD = 'complex_keyword_field',

  // Information fields
  INSTRUCTION = 'instruction'
}

export type DependencyDisabledBehavior = 'disable' | 'hideAndClear';

/**
 * Represents a field instance in the form
 */
export interface Field {
  id: string;                 // Unique identifier
  key: string;                // Field key for form data
  type: FieldType;            // Type of the field
  label: string;              // Display label
  required: boolean;          // Whether the field is required
  readOnly: boolean;          // Whether the field is read-only
  value: any;                 // Field value
  // Field dependency properties
  dependsOn?: string;         // ID of the Yes/No field this field depends on
  enableWhen?: boolean;       // Enable current field when dependency field equals this value
  disabledBehavior?: DependencyDisabledBehavior;
  defaultValue?: string | string[] | number | number[] | Date | boolean | null; // Default value for the field
  contextType?: number;
  [key: string]: any;         // Additional dynamic properties
}

/**
 * Strategy pattern interface for field type implementations
 */
import { EditorComponent } from './editor-component.model';
import { FieldTypeConfig } from './field-type.model';

export interface FieldTypeStrategy {
  getEditorConfig(): { components: EditorComponent[] };  // Get editor configuration
  getConfig(): FieldTypeConfig;                         // Get field configuration
  createField(config: any): any;                        // Create field instance
  validateValue(value: any): boolean;                   // Validate field value
}

/**
 * Field validation interface
 */
export interface FieldValidator {
  type: string;              // Validator type
  message: string;           // Error message
  validate: (value: any) => boolean;  // Validation function
}

/**
 * Field editor configuration
 */
export interface FieldEditorConfig {
  components: EditorComponent[];
}
